export const getPaperData = () => {
  const data = typeof window !== 'undefined' ? window.__PAPER_DATA__ : null;
  return data !== null && typeof data === 'object' ? data : null;
};

export const requireValue = (value, label) => {
  if (
    value === undefined ||
    value === null ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  ) {
    throw new Error(`Missing ${label}`);
  }
  return value;
};

const requireArray = (value, label) => {
  if (!Array.isArray(value)) {
    throw new Error(`Missing ${label}`);
  }
  return value;
};

export const assertStatementData = (data) => {
  requireValue(data, 'paper data');
  requireValue(data.statement, 'statement');
  requireArray(data.statement.statementCharges?.items, 'statement.statementCharges.items');
  requireArray(data.statement.statementCredits?.items, 'statement.statementCredits.items');
  requireValue(data.statement.propertyId, 'statement.propertyId');
  requireValue(data.statistic, 'statistic');
  requireArray(data.statistic.residentPortion, 'statistic.residentPortion');
  requireArray(data.statistic.monthlyBillingHistory, 'statistic.monthlyBillingHistory');
  requireValue(data.utilityInfo, 'utilityInfo');
  requireArray(data.utilityInfo.utilities, 'utilityInfo.utilities');
  requireValue(data.property, 'property');
  requireValue(data.property.propertyAddress, 'property.propertyAddress');
  requireValue(data.resident, 'resident');
  requireValue(data.resident.firstName, 'resident.firstName');
  requireValue(data.resident.lastName, 'resident.lastName');
  requireArray(data.voidedTransactions, 'voidedTransactions');
  requireArray(data.tips, 'tips');
  return data;
};

export const assertInviteData = (data) => {
  requireValue(data, 'paper data');
  requireValue(data.overview, 'overview');
  requireValue(data.overview.propertyId, 'overview.propertyId');
  requireValue(data.overview.residentAccountId, 'overview.residentAccountId');
  requireValue(data.property, 'property');
  requireValue(data.property.propertyAddress, 'property.propertyAddress');
  requireArray(data.utilityProviders, 'utilityProviders');
  requireValue(data.billingSettings, 'billingSettings');
  requireArray(data.billingSettings.residencyUtilities, 'billingSettings.residencyUtilities');
  requireArray(data.billingSettings.residencyUtilityOptOuts, 'billingSettings.residencyUtilityOptOuts');
  requireArray(data.profiles, 'profiles');
  const resident = data.profiles.find((i) => i.id === data.overview.residentAccountId);
  requireValue(resident, 'resident profile');
  requireValue(resident.firstName, 'resident.firstName');
  requireValue(resident.lastName, 'resident.lastName');
  return data;
};
